import Spinner from "../../shared/Spinner/Spinner";
import { Button, Modal as BootstrapModal } from "react-bootstrap";
import { ReactElement } from "react";

export interface Popup {
  show: boolean,
  loading: boolean,
  title?: string,
  body?: string | ReactElement<any>,
  primaryText?: string,
  secondaryText?: string,
  primaryDisabled?: boolean,
  secondaryDisabled?: boolean,
  onHide?: () => void,
  primaryOnClick?: () => void,
  secondaryOnClick?: () => void,
}
export default function TwoButtonsModal(popup: Popup) {

  return (
    <BootstrapModal
      show={popup.show}
      onHide={popup.onHide}
      backdrop="static"
      keyboard={false}
      dialogClassName="custom-modal"
    >

      <BootstrapModal.Header>
        <BootstrapModal.Title>{popup.title}</BootstrapModal.Title>
      </BootstrapModal.Header>

      <BootstrapModal.Body>
        {popup.body}
      </BootstrapModal.Body>
      <Spinner spinning={popup.loading} />
      <BootstrapModal.Footer>
        {popup.secondaryText && popup.secondaryText?.length > 0 && < Button
          variant="secondary"
          onClick={popup.secondaryOnClick}
          disabled={popup.secondaryDisabled}
        >{popup.secondaryText}</Button>}
        <Button
          variant="primary"
          onClick={popup.primaryOnClick}
          disabled={popup.primaryDisabled}
        >{popup.primaryText}</Button>
      </BootstrapModal.Footer>
    </BootstrapModal >
  );
}
